import { Table } from 'semantic-ui-react';
import { minToHour, msToHour } from '../utils';

function TotalTable({ duration, clicks, keystrokes, startToEnd }) {
    return (
        <Table striped className="revewRequiestTable">
            <Table.Body>
                <Table.Row>
                    <Table.Cell className="redFont">{minToHour(duration)}</Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell>{clicks}</Table.Cell>
                    <Table.Cell>{keystrokes}</Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell>{msToHour(startToEnd)}</Table.Cell>
                </Table.Row>
            </Table.Body>
        </Table>
    );
}

export default TotalTable;
